import React from "react";
import { NavigationContainer } from "@react-navigation/native";
import { navigationRef } from '../utils/navigation'

import PageRoutes from "./page.routes";
const linking = {
  config: {
    screens: {
      Tabs: {
        screens: {
          Exchange: "exchange",
          Marketplace: "marketplace",
          MarketplaceCategories: "categoriasmarketplace"
        },
      },
      UpdateRegistration: "updateregistration",
      Welcome: "home",
      Login: "login",
      DetailsCoin: "detailscoin",
      Token: "token",
      NotFound: "404",
      Wallet: "wallet",
      ConfirmPurchaseOrSell: "confirm"
    }
  },
  stringify: {
    token: (token) => `@{token}`,
  },
};
const Routes = () => (
  // <NavigationContainer linking={linking} ref={navigationRef}>
  <NavigationContainer ref={navigationRef}>
    <PageRoutes />
  </NavigationContainer>
);

export default Routes;
